<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Delete selected plant?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected plant.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn color="accent" flat @click="deletePlantById" :loading="isLoading" :disable="isLoading">delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Details</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <v-card-title>
            <v-btn dark color="accent" to="/plant/new">new plant</v-btn>
            <v-spacer></v-spacer>
            <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table :loading="isLoading" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" v-model="selected"
              item-key="id" class="elevation-0">
              <template slot="headerCell" slot-scope="props">
                <span>
                  {{ props.header.text }}
                </span>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <v-tooltip bottom>
                    <v-btn flat icon @click="editPlantById(props.item.id)" color="accent lighten-1" slot="activator">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span>Change</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon @click="toggleDialog(props.item.id)" color="error lighten-1" slot="activator">
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <span>Delete</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">{{ props.item.id}}</td>
                <td class="text-xs-left">{{ props.item.plant}}</td>
                <td class="text-xs-left">{{ props.item.description}}</td>
                <td class="text-xs-left">{{ props.item.company_code}}</td>
              </template>
            </v-data-table>
          </v-card-text>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'plant-detail',
  data () {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        {
          text: 'Plant',
          align: 'left',
          value: 'plant'
        },
        {
          text: 'Description',
          align: 'left',
          value: 'description'
        },
        {
          text: 'Company Code',
          align: 'left',
          value: 'company_code'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions(['fetchAllPlants', 'deletePlant']),
    /**
     *
     * @param id
     */
    editPlantById: function (id) {
      this.$router.push({ name: 'changePlant', params: { id: id } })
    },
    /**
     *
     * @param id
     */
    toggleDialog: function (id) {
      this.selectedId = id
      this.dialog = true
    },
    /**
     *
     */
    deletePlantById: function () {
      this.deletePlant(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },
    /**
     *
     */
    loadPlants: function () {
      this.fetchAllPlants()
        .then(() => {
          //  do nothing
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted: function () {
    this.loadPlants()
  },
  computed: {
    ...mapGetters({
      items: 'getAllPlants',
      isLoading: 'getLoading',
      getResponse: 'getResponse'
    })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/plant/PlantDetail.vue